import React, { createContext, useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Lightbox from 'react-image-lightbox';
import { store } from '../../App';
import { Helmet } from "react-helmet-async";
import axios from 'axios';

function GallaryTwo() {

  const [photoIndex, setPhotoIndex] = useState(0);
  // const [isOpen, setIsOpen] = useState(false);

  const[products,setProducts]=useState()
    const[loading,setisLoading]=useState(false)
  


  const [menus, setMenus, isOpen, setIsOpen, navbarclose, setNavbarClose] = useContext(store)

  // const products = [
  //   { image: "Images/gallery/1.jpg", title: "", link: "capsule-elevators", id: 1 },
  //   { image: "Images/gallery/2.jpg", title: "", link: "passenger-Elevators", id: 2 },
  //   { image: "Images/gallery/3.jpg", title: " ", id: 3 },
  //   { image: "Images/gallery/4.jpg", title: "", id: 4 },
  //   { image: "Images/gallery/5.jpg", title: "", link: "capsule-elevators", id: 5 },
  //   { image: "Images/gallery/6.jpg", title: "", link: "passenger-Elevators", id: 6 },
  //   { image: "Images/gallery/7.jpg", title: ".", link: "passenger-elevators-autodoor", id: 7 },
  //   { image: "Images/gallery/8.jpg", title: " ", id: 8 },
  //   { image: "Images/gallery/9.jpg", title: "", link: "capsule-elevators", id: 9 },
  //   { image: "Images/gallery/10.jpg", title: "", link: "passenger-Elevators", id: 10 },
  //   { image: "Images/gallery/11.jpg", title: "", link: "passenger-elevators-autodoor", id: 11 },
  //   { image: "Images/gallery/12.jpg", title: "", id: 12 },
  //   { image: "Images/gallery/13.jpg", title: "", link: "capsule-elevators", id: 13 },
  //   { image: "Images/gallery/14.jpg", title: "", link: "passenger-Elevators", id: 14 },
  //   { image: "Images/gallery/15.jpg", title: "", link: "passenger-elevators-autodoor", id: 15 },
  //   { image: "Images/gallery/16.jpg", title: "", id: 16 },

  // ]

  useEffect(()=>{

    const fetchdata = async ()=>{
      try{
        const response = await axios.get('https://admin.techno-elevators.com/api/getGalleryPageDataBySlug/gallery')
        setProducts(response.data.data.galleries)
        setisLoading(true)
      }
      catch(err){
        console.log(err)
      }
    }
    fetchdata()

  },[])



  return (
    <>
      <Helmet>
        <title>Gallery | Techno Elevators Oman – Our Work in Pictures</title>
        <meta name="description" content="Get a closer look at the high-quality elevator and escalator systems installed by Techno Elevators Oman. Browse images of real-world applications and satisfied clients." />

  <meta name="keywords" content="techno elevators for villas,techno elevators for office buildings,commercial techno lift installation,high-rise techno elevators,techno elevator services in Muscat,elevator installation cost,home elevator installation near me,residential elevator installation,home elevator installers,lift installation services,elevator repair near me" />
  <link rel="canonical" href="https://www.techno-elevators.com/gallery" />
      </Helmet>

      {loading ? 
      <>
      <div>
        <div className="gallery">
          <div className="gallery__strip__wrapper">
            <div className="gallery__strip one">
              <div className="photo">
                {products && products.slice(0, 4).map((item) => {
                  return (
                    <>
                      <div className="photo__image" as={Link} to={item.link}>
                      
                        <img src={item.image} alt="emergency repair for techno elevators" onClick={() => { setIsOpen(true); setPhotoIndex(item.id); setNavbarClose("navbar-close") }} />
                      </div>
                      <div className="photo__name">
                        {item.title}
                      </div>
                    </>
                  )
                })}
              </div>
            </div>
          </div>

          <div className="gallery__strip__wrapper">
            <div className="gallery__strip four">
              <div className="photo">
                {products && products.slice(4, 8).map((item) => {
                  return (
                    <>
                      <div className="photo__image"><img src={item.image} alt='Techno elevator maintenance service' onClick={() => { setIsOpen(true); setPhotoIndex(item.id); setNavbarClose("navbar-close") }} /></div>
                      <div className="photo__name">{item.title}</div>
                    </>
                  )
                })}
              </div>
            </div>
          </div>

          <div className="gallery__strip__wrapper">
            <div className="gallery__strip two">
              <div className="photo">
                {products && products.slice(8, 12).map((item) => {
                  return (
                    <>
                      <div className="photo__image"><img src={item.image} alt='Energy-efficient techno lift systems' onClick={() => { setIsOpen(true); setPhotoIndex(item.id); setNavbarClose("navbar-close") }} /></div>
                      <div className="photo__name">{item.title}</div>
                    </>
                  )
                })}
              </div>
            </div>
          </div>

          <div className="gallery__strip__wrapper">
            <div className="gallery__strip three">
              <div className="photo">
                {products && products.slice(12, 16).map((item) => {
                  return (
                    <>
                      <div className="photo__image"><img src={item.image} alt='Customized techno elevators for commercial use' onClick={() => { setIsOpen(true); setPhotoIndex(item.id); setNavbarClose("navbar-close") }} /></div>
                      <div className="photo__name">{item.title}</div>
                    </>
                  )
                })}
              </div>
            </div>
          </div>

        </div>
      </div>

      <div>
        {isOpen && (
          <Lightbox
            mainSrc={products[photoIndex].image}
            nextSrc={products[(photoIndex + 1) % products.length].image}
            prevSrc={products[(photoIndex + products.length - 1) % products.length].image}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + products.length - 1) % products.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % products.length)
            }
          />
        )}f

      </div>
      </>
      :

      <div className='loader-header'>
        <span class="loader"></span>
        </div>
      
      }

    </>
  )
}

export default GallaryTwo





















